import { api } from "./api";

export const postImagem = (cdAnuncio: number, cdUsuarioAlt: number, cdUsuarioInc: number, formData: FormData) => {
  return api.post(`Imagem/incluir/${cdAnuncio}`, formData, {
    params: {
      cdUsuarioAlt: cdUsuarioAlt,
      cdUsuarioInc: cdUsuarioInc,
    }
  });
};

export const putImagem = (cdImagem: number, cdAnuncio: number, cdUsuarioAlt: number, cdUsuarioInc: number, dmSituacao: boolean, formData: FormData) => {
  return api.put(`Imagem/alterar/${cdImagem}`, formData, {
    params: {
      cdAnuncio: cdAnuncio,
      cdUsuarioAlt: cdUsuarioAlt,
      cdUsuarioInc: cdUsuarioInc,
      dmSituacao: dmSituacao,
    }
  });
};

export const getImagens = async (numeroPagina: string) => {
  try {
    const response = await api.get(`Imagem/buscartodos/${numeroPagina}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getImagensAnuncio = async (cdAnuncio: any) => {
  try {
    const response = await api.get(`Imagem/buscar-imagem-por-anuncio/${cdAnuncio}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getImagensSemArquivo = async (cdAnuncio: string) => {
  try {
    const response = await api.get(`Imagem/buscartodos/${cdAnuncio}`);
    const imagens = response.data;

    const imagensSemMdArquivo = imagens.map((imagem: any) => {
      const { mdArquivo, ...rest } = imagem;
      return rest;
    });

    return imagensSemMdArquivo;
  } catch (error) {
    console.error(error);
    return [];
  }
}

export const getImagemCapa = async (cdAnuncio: number | string) => {
  try {
    const imagens = await getImagensSemArquivo(cdAnuncio.toString());

    if (!imagens.some((imagem: any) => imagem.cdAnuncio === parseInt(cdAnuncio.toString()))) {
      return null;
    }

    const response = await api.get(`Imagem/buscarCapa/${cdAnuncio}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export const putImagemCapa =  async (dados : any) => await api.put(`Imagem/alterarCapa`, dados);